export const zoom = {
  step: 10,
  min: 10,
  max: 500,
  options: [
    {
      label: '',
      labelKey: 'tool.bottom_bar.zoom.fit',
      value: 'fit',
    },
    {
      label: '100%',
      value: '100',
    },
    {
      label: '200%',
      value: '200',
    },
    {
      label: '300%',
      value: '300',
    },
    {
      label: '400%',
      value: '400',
    },
    {
      label: '500%',
      value: '500',
    },
  ],
};

export const languages = [
  'en',
  'ar',
  'ca',
  'zh',
  'nl',
  'fr',
  'fr-CA',
  'de',
  'el',
  'he',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'pl',
  'pt',
  'pt-BR',
  'ru',
  'sr',
  'sk',
  'sl',
  'es',
  'es-MX',
  'sv',
  'th',
  'tr',
  'vi',
];
